<template>
    <div id="searchList" ref="searchList">
        <div class="searchTop">
            <div class="ltx">
                <form method="post" action=""  onsubmit="return false;">
                    <input type="search" class="ipt" v-model="value" @keyup="searchVal" autofocus ref="keyIpt">
                </form>
                <!-- <i class="close"></i> -->
            </div>
            <a href="javascript:;" class="cancle" @click="cancle()">取消</a>
        </div>
        <div class="setFix"></div>
        <div class="outerWrap" ref="outerWrap"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="disabled"
            infinite-scroll-distance="0">
            <ul class="searchBox">
                <li v-for="item in searchList">
                    <div class="left">
                        <p class="name" @click="intoIndex(item)">{{item.name}}</p>
                        <p class="address">{{item.cityname}}{{item.adname}}{{item.address.length==0?'':item.address}}</p>
                    </div>
                </li>
                <li ref="bottom" style="display: block;text-align: center;border-bottom:0;"></li>
            </ul>
        </div>
        <div class="noLists" v-show="noShow&&searchList.length==0">
            <img src="~@/assets/imgs/bg.png" alt="">
            <p>这里空空如也~</p>
        </div>
    </div>
</template>
<script>
import MapLoader from "@/assets/js/AMap.js";
import { Indicator, Toast } from "mint-ui";
import axios from "axios";
export default {
  data() {
    return {
      value: "",
      noShow: false,
      searchList: [],
      page: 1,
      disabled: false,
      result: [{ title: "123", value: "432" }],
    };
  },
  mounted(val) {},
  methods: {
    cancle() {
      this.$router.go(-1);
    },
    intoIndex(item) {
      let _this = this;
      axios
        .post(this.commonIp() + "/v1/mobile/community/edit", {
          poiId: item.id,
          token: this.getuserToken(),
        })
        .then((res) => {
          this.$router.push({
            path: "/",
            query: {
              poiId: item.id,
              lng: item.location.split(",")[0],
              lat: item.location.split(",")[1],
            },
          });
        });
    },
    search(val, page) {
      Indicator.open();
      this.disabled = true;
      // 120302|120201

      // 120302|120201|120000  141200大学
      axios
        .get(
          `https://restapi.amap.com/v3/place/text?key=${localStorage.getItem(
            "key"
          )}&types=120000|120302|120201|141200&city=010&keywords=${this.value}&page=${
            this.page
          }`
        )
        .then((res) => {
          Indicator.close();
          let newPois = res.data.pois.filter(
            (item) =>
              item.id != "B000A844UJ" &&
              item.id != "B0FFK4ECAV" &&
              item.id != "B0FFFOZLJF"
          );
          // let newPois = res.data.pois
          if (newPois.length != 0) {
            if (newPois.length == 1) {
              this.searchList = this.searchList.concat(newPois);
            } else {
              this.searchList = this.searchList.concat(newPois);
              ++this.page;
              this.disabled = false;
              if (res.data.count < 20) {
                this.isFoot = true;
              }
            }
          } else {
            this.disabled = true;
          }
        })
        .catch((error) => {
          Indicator.close();
          if (page == 1) {
            return;
          }
          this.$refs.searchList.scrollTop =
            this.$refs.searchList.scrollTop - this.$refs.bottom.offsetHeight;
          this.disabled = false;
        });
    },
    searchVal(e) {
      if (!e) e = window.event;
      if (e.keyCode == 13) {
        this.searchList = [];
        this.page = 1;
        this.value = e.target.value;
        this.search(this.value, this.page);
        if (this.searchList.length == 0) {
          this.noShow = true;
        }
        this.$refs.keyIpt.blur();
      }
    },
    loadMore() {
      this.search(this.value, this.page);
    },
  },
};
</script>
<style lang="less">
@import "~@/assets/less/index.less";
::-webkit-scrollbar {
  display: none;
}
#container {
  width: 100%;
  height: 200px;
}
#searchList {
  position: relative;
  height: 100vh;
  overflow: scroll;
  // .outerWrap{
  // height:100vh;
  // overflow: scroll;
  // }
  .searchTop {
    padding: 8px 15px;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    background: #fff;
    box-sizing: border-box;
    .ltx {
      display: inline-block;
      position: relative;
      width: 83%;
      .ipt {
        position: relative;
        width: 100%;
        border: 1px solid #d8d8d8;
        background-image: url("~@/assets/imgs/s2.png");
        background-repeat: no-repeat;
        background-position: 10px center;
        background-color: #f2f2f2;
        background-size: 13px;
        padding-left: 32px;
        height: 29px;
        outline: none;
        border-radius: 4px;
        box-sizing: border-box;
      }
    }
    .cancle {
      width: 15%;
      display: inline-block;
      color: @gray;
      text-align: right;
      font-size: @ft16;
    }
  }
  .searchBox {
    li {
      display: flex;
      padding: 15px;
      font-size: @ft14;
      align-items: center;
      border-bottom: 1px solid #d8d8d8;
      &:first-child {
        border-top: 1px solid #d8d8d8;
      }
      .left {
        flex: 1;
        width: 80%;
        .name {
          font-size: @ft16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .address {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: @ft14;
          color: @gray;
          margin: 5px 0 0 0;
        }
      }
      .right {
        width: 50px;
        font-size: @ft14;
        color: @gray;
        flex: 0 0 50px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/searchlist/searchlist.vue